import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Entities } from '../../../../core/models/globals';
import { NavigationService } from '../../../../core/services/navigation.service';

@Component({
  selector: 'app-gateway-left-panel',
  templateUrl: './gateway-left-panel.component.html',
  styleUrls: ['./gateway-left-panel.component.scss']
})
export class GatewayLeftPanelComponent implements OnInit {

  properties = [
    {
      name: 'Gateways',
      routerLink: 'Gateways',
      spanClass: 'bi bi-arrow-left-right',
    },
    {
      name: 'Logs',
      routerLink: 'Logs',
      spanClass: 'bi bi-body-text',
    },
  ];

  selectedIndex: number;

  constructor(private navService: NavigationService,
    private router: Router, private route: ActivatedRoute) { }


  ngOnInit(): void {
    this.navService.sendParentData(Entities.Gateway);
    this.navService.index.subscribe(x => {
      this.selectedIndex = x;
    })
  }

  sendData(index: number, property) {
    if (this.selectedIndex != index) {
      this.selectedIndex = index;
      //this.navService.sendParentData(property.name);
      //this.navService.sendLeftpanelIndex(index);
      this.router.navigate([property.routerLink], { relativeTo: this.route })
    }
  }

}
